// Version : 0.0.1
// Author :
// LastEdit : 
// Last ADD : INITIAL CREATION
// MODIFIED DATE: 

const ThriftReportActionTypes = {
	/******************* FETCH THRIFT REPORT START  ******************************** */
	FETCH_THRIFT_REPORT_START: 'fetch_thrift_report_start',
	FETCH_THRIFT_REPORT_SUCCESS: 'fetch_thrift_report_success',
	FETCH_THRIFT_REPORT_FAILURE: 'fetch_thrift_report_failure',
	FETCH_THRIFT_REPORT_RESPONSE_RESET: 'fetch_thrift_report_response_reset',
	FETCH_THRIFT_REPORT_RESPONSE_CHANGED: 'fetch_thrift_report_response_changed',
	/******************* FETCH THRIFT REPORT END  ******************************** */
};
export default ThriftReportActionTypes;

